import { CthResultsScreen } from '@/screens/completeTheHand/CthResultsScreen'

export default function () {
  return <CthResultsScreen />
}
